import { useSelector } from 'react-redux';
import AddIcon from '@mui/icons-material/Add';
import { DeleteForever } from '@mui/icons-material';

const FromSchemeForm = ({
    handleChallanFormData, 
    schemeLoading, 
    screenType,
    fromSchemeDetails, 
    subheadsList, 
    fromSubheadData, 
    handleSubheadChange, 
    handleFinancialYearChange, 
    fy_list, 
    schemes, 
    handleSchemeChange,
    totalFromAmount,
    handleFromActivityChange,
    activity,
    findSubActivitiesById,
    addNewActivity,
    deleteNewActivity,
    handleFromSubheadSave
}) => {
    const { authData } = useSelector((state) => state.authData);

    return (
        <>
            <div className='col-md-12'>
                <h5>From Scheme</h5>
            </div>
            <div className='col-md-4'>
                <div className="form-group">
                    <label for="inputFinancial" className="col-form-label"> Financial Year <span className="text-danger">*</span> :</label>
                    <select className="form-control " id="financial_year"
                        name='financial_id'
                        value={fromSchemeDetails.financial_id}
                        onChange={handleFinancialYearChange}
                        disabled={schemeLoading || screenType == "View" || screenType == "Edit"}
                        required
                    >
                        <option value="">---select year---</option>
                        {
                            fy_list.map((fy) => {
                                return (
                                    <option value={fy.id}
                                        key={fy.id}>{fy.year}</option>
                                );
                            })
                        }
                    </select>
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-group">
                    <label for="from_scheme_id" className="col-form-label">Scheme <span className="text-danger">*</span></label>
                    <select className="form-control "
                        id="from_scheme_id" name='from_scheme_id'
                        required
                        value={fromSchemeDetails.scheme_id}
                        disabled={screenType == "View" || screenType == "Edit"}
                        onChange={handleSchemeChange}
                    // disabled={!formData.department_Id}
                    >
                        <option>Select Scheme</option>
                        {
                            schemes.map((schemes) => {
                                return (
                                    schemes.l2_status == 1 && schemes.l3_status == 1 &&
                                    <option value={schemes.id}
                                        key={schemes.id}>{schemes.code}</option>
                                );
                            })
                        }
                    </select>
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-group">
                    <label className="col-form-label">Scheme Name</label>
                    <input type="text" className="form-control" value={fromSchemeDetails.scheme_name} readonly />
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-group">
                    <label className="col-form-label">Department Name</label>
                    <input type="text" className="form-control" value={fromSchemeDetails.department_name} readonly />
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-group">
                    <label className="col-form-label">Grant Code</label>
                    <input type="text" className="form-control" value={fromSchemeDetails.grant_code} readonly />
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-group">
                    <label className="col-form-label">Type of Scheme</label>
                    <input type="text" className="form-control" value={fromSchemeDetails.scheme_type} readonly />
                </div>
            </div>
            <div className='col-md-12 mt-3'>
                <h5>From Subhead</h5>
            </div>
            <div className='col-md-4'>
                <div className="form-group">
                    <label for="inputFinancial" className="col-form-label"> Subhead <span className="text-danger">*</span> :</label>
                    <select className="form-control " id="financial_year"
                        name='from_subhead_id'
                        onChange={handleSubheadChange}
                        value={fromSubheadData.from_subhead_id}
                        required
                        disabled={!fromSchemeDetails.scheme_id || screenType == "View"}>
                        <option value="">---Select Subhead---</option>
                        {
                            subheadsList.map((subhead) => {
                                return (
                                    <option
                                        value={subhead.id}
                                        key={subhead.id}>{subhead.code}</option>
                                );
                            })
                        }
                    </select>
                </div>
            </div>

            <div className="col-md-4">
                <div className="form-group">
                    <label className="col-form-label">Subhead Name</label>
                    <input type="text" className="form-control" value={fromSubheadData.subhead_name} readonly />
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-group">
                    <label className="col-form-label">Subhead Balance</label>
                    <input type="text" className="form-control" value={fromSubheadData.subhead_balance} readonly />
                </div>
            </div>
            <div className="col-md-4">
                <div className="form-group">
                    <label className="col-form-label">Reappropriation Amount</label>
                    {fromSchemeDetails.is_activity_active == 1 && <input type="text"
                        className="form-control"
                        value={totalFromAmount.current}
                        readOnly
                    />}
                    {fromSchemeDetails.is_activity_active == 0 && <input type="text"
                        className="form-control"
                        name="from_reappropriation_amount"
                        value={fromSubheadData.from_reappropriation_amount}
                        onChange={handleChallanFormData}
                    />}
                </div>
            </div>
            {fromSchemeDetails.is_activity_active == '1' && ((fromSchemeDetails.monitoring_level == "3" && authData.user.department_details.department_level != 'T1') || (fromSchemeDetails.monitoring_level != "3")) && <div className="col-md-12" style={{ marginTop: '20px' }}>
                <table className="table table-bordered" style={{ tableLayout: 'auto' }}>
                    <thead className="text-center-custom">
                        <tr>
                            <th scope="col" width="150px">Activity</th>
                            <th scope="col" width="150px">Subactivity</th>
                            <th scope="col" width="300px">Available Balance</th>
                            <th scope="col" width="300px">Amount</th>
                            <th scope="col" width="150px">Action</th>
                        </tr>
                    </thead>
                    <tbody className="text-center-custom">
                        {fromSubheadData?.activity.map((activityData, index) => (
                            <tr key={index}>
                                <td>
                                    <select
                                        className="form-control"
                                        name='activity_id'
                                        value={activityData.activity_id}
                                        onChange={(e) => handleFromActivityChange(index, e)}
                                        disabled={!fromSubheadData.from_subhead_id}>
                                        <option value="">---Select---</option>
                                        {activity.map(activity => {
                                            if (fromSubheadData?.activity_budget && fromSubheadData?.activity_budget.length) {
                                                const exists = fromSubheadData?.activity_budget.find(e => e.subhead_activity_id == activity.id);

                                                if (exists) {
                                                    return (
                                                        <option key={activity.id} value={activity.id}>{activity.activity}</option>
                                                    )
                                                }
                                            }
                                            else {
                                                if (fromSchemeDetails.monitoring_level == "2") {
                                                    return (
                                                        <option key={activity.id} value={activity.id}>{activity.activity}</option>
                                                    )
                                                }
                                            }
                                        })}
                                    </select>
                                </td>
                                <td>
                                    <select
                                        className="form-control"
                                        name='subactivity_id'
                                        value={activityData.subactivity_id}
                                        onChange={(e) => handleFromActivityChange(index, e, activityData.activity_id)}
                                        disabled={!fromSubheadData.from_subhead_id}>
                                        <option value="">---Select---</option>
                                        {findSubActivitiesById(activityData.activity_id).map(e => {
                                            if (fromSubheadData?.activity_budget && fromSubheadData?.activity_budget.length) {
                                                const exists = fromSubheadData?.activity_budget.find(item => item.subhead_subactivity_id == e.id);
                                                if (exists) {
                                                    return (
                                                        <option key={e.id} value={e.id}>{e.subactivity}</option>
                                                    )
                                                }
                                            }
                                            else {
                                                if (fromSchemeDetails.monitoring_level == "2") {
                                                    return (
                                                        <option key={e.id} value={e.id}>{e.subactivity}</option>
                                                    )
                                                }
                                            }
                                        }
                                        )}
                                    </select>
                                </td>
                                <td>{fromSubheadData?.activity_budget && fromSubheadData?.activity_budget.length != 0 && fromSubheadData?.activity_budget.find(e =>
                                    e.subhead_activity_id === activityData.activity_id &&
                                    e.subhead_subactivity_id === activityData.subactivity_id
                                )?.budget}</td>
                                <td>
                                    <input
                                        type="number"
                                        className="form-control"
                                        name='budget'
                                        placeholder="Enter Release Budget"
                                        value={activityData?.budget}
                                        disabled={!fromSubheadData.from_subhead_id || screenType == "View"}
                                        onChange={(e) => handleFromActivityChange(index, e)}
                                    />
                                </td>
                                <td>
                                    <button className="btn btn-primary mx-2" onClick={(e) => addNewActivity('from')}>
                                        <AddIcon />
                                    </button>
                                    {index != 0 && <button type="button"
                                        className="btn btn-danger mx-2"
                                        onClick={(e) => deleteNewActivity(index, 'from')}>
                                        <DeleteForever /></button>}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>}
            {screenType != 'View' && <div className='col-md-12'><button type="button" onClick={handleFromSubheadSave} className='btn btn-primary mt-2'>Add From Subhead</button></div>}
        </>
    );
}

export default FromSchemeForm;